const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/invitation_links/$id/edit/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
import { EDIT_INVITATION_LINK_TAB_PATHS, INVITATION_LINK_TAB } from "@/react/components/SettingsApp/InvitationLinks/InvitationLinkViewModal/constants";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/invitation_links/$id/edit/")({
  beforeLoad: ({
    params,
    location
  }: {
    params: {
      id: string;
    };
    location: ParsedLocation;
  }) => {
    redirect({
      to: EDIT_INVITATION_LINK_TAB_PATHS[INVITATION_LINK_TAB.DETAILS],
      params: {
        id: params.id
      },
      replace: true,
      search: true,
      state: location.state,
      throw: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});